"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var Typography_1 = require("src/components/Typography");
var error_1 = __importDefault(require("./error"));
var Field = function (_a) {
    var label = _a.label, error = _a.error, htmlFor = _a.htmlFor, children = _a.children, rest = __rest(_a, ["label", "error", "htmlFor", "children"]);
    return (react_1.default.createElement(Box_1.default, __assign({ gap: 1, column: true }, rest),
        label && (react_1.default.createElement(Typography_1.Text, { as: "label", htmlFor: htmlFor }, label)),
        children,
        error && react_1.default.createElement(error_1.default, null, error)));
};
exports.default = Field;
